import Snackbar from "@mui/material/Snackbar";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

export default function ToastSnackbar({
  open,
  message,
  onClose,
  action,
  autoHideDuration = 2000,
  toastType = "info",
}) {
  // Unified grey styling for all toast variants
  const baseStyle = { backgroundColor: "#3d3d44", color: "#E5E7EB" };
  const toastStyles = {
    success: baseStyle,
    error: baseStyle,
    info: baseStyle,
  };

  return (
    <Snackbar
      open={open}
      autoHideDuration={autoHideDuration}
      onClose={onClose}
      message={message}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      ContentProps={{
        sx: {
          px: 3,
          py: 1.5,
            fontSize: 14,
            fontWeight: 500,
            ...toastStyles[toastType],
        },
      }}
      action={
        <>
          {action}
          <IconButton
            size="small"
            aria-label="close"
            color="inherit"
            onClick={onClose}
            sx={{ color: "#9CA3AF" }}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </>
      }
    />
  );
}
